document.addEventListener("DOMContentLoaded", () => {
  
  function prepareClarityWaveAnimations() {
    // Target any element containing the class, irrespective of tag type
    const targets = document.querySelectorAll(".animate-sub-h2");
 
    
    targets.forEach(el => {
      // 1. Capture the original HTML structure verbatim to preserve your custom <br /> tags
      const originalHTML = el.innerHTML.trim();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = originalHTML;
      
      // 2. Locate all text pieces across child elements safely
      const textNodes = [];
      const walk = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
      let n;
      while (n = walk.nextNode()) {
        textNodes.push(n);
      }
      
      const rhythmStep = 20; // Fast execution tracking (12ms) for immediate scrolling response
      let globalTimelineTracker = 0;
      let globalWordCounter = 0;
      
      // 3. Rebuild text pieces into individual letters while leaving HTML breaks exactly where they were
      textNodes.forEach(node => {
        const text = node.nodeValue;
        if (!text.trim()) return; // Skip over empty structural white space
        
        const words = text.split(/(\s+)/);
        const fragment = document.createDocumentFragment();
        
        words.forEach(word => {
          if (word.trim() === '') {
            fragment.appendChild(document.createTextNode(word));
          } else {
            const wordSpan = document.createElement('span');
            wordSpan.classList.add('h2-sub-animated-word');
            
            // Flag the very first detected text block globally across line breaks
            if (globalWordCounter === 0) {
              wordSpan.classList.add('is-first-word');
            }
            globalWordCounter++;
            
            wordSpan.style.setProperty("--blur", "8px");
            
            const letters = word.split("");
            letters.forEach(letter => {
              const letterSpan = document.createElement('span');
              letterSpan.style.setProperty('--letter-delay', globalTimelineTracker);
              letterSpan.textContent = letter;
              
              wordSpan.appendChild(letterSpan);
              globalTimelineTracker += rhythmStep; // Smooth left-to-right calculation ramp
            });
            
            fragment.appendChild(wordSpan);
            globalTimelineTracker += rhythmStep; // Minor delay gap between word completions
          }
        });
        
        node.parentNode.replaceChild(fragment, node);
      });
      
      // 4. Wrap everything inside our screen-reader accessibility layers
      const finalProcessedContent = tempDiv.innerHTML;
      const cleanStrippedText = tempDiv.textContent.replace(/\s+/g, ' ').trim();
      
      el.innerHTML = `
        <div class="h2-sub-animated-block">
          <span class="h2-sub-visually-hidden">${cleanStrippedText}</span>
          <span role="presentation" aria-hidden="true" class="h2-sub-presentation-wrapper">
            ${finalProcessedContent}
          </span>
        </div>
      `;
    });
  }

  prepareClarityWaveAnimations();

  // Handle active viewport boundary triggers
  const waveObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("h2-sub-triggered");
        waveObserver.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: "170px 0px 0px 0px"
  });

  // Observe all elements with the animation class
  document.querySelectorAll(".animate-sub-h2").forEach(el => {
    waveObserver.observe(el);
  });
});